import { AxiosResponse } from 'axios';
import { axiosInstance } from '../axios';
import { AddReportModel } from '../../components/add-report/addReportInterfaces';
import { EditReportModel } from '../../components/report-dashboard/EditReport/editReportInterfaces';
import { ApiResponse } from '../models/ApiResponse';
import { PowerBIReport, Report, ReportView } from '../models/Report';

export const GetReportById = async (id: string) => {
  const result = await axiosInstance.get<ApiResponse<ReportView>>(
    `reports/${id}`
  );
  return result.data.data;
};

export const GetPowerBIWorkspaces = async () => {
  const result = await axiosInstance.get<ApiResponse<PowerBIReport[]>>(
    'reports/pbi/workspaces/'
  );
  return result.data.data;
}

export const GetPowerBIReportsByWorkspaceId = (workspaceID:string): Promise<AxiosResponse<PowerBIReport[]>> => {
  return axiosInstance.get(`reports/pbi/workspaces/${workspaceID}/reports`);
};

export const GetPowerBIReportEmbedConfig = (reportId:string): Promise<AxiosResponse<PowerBIReport>> => {
  return axiosInstance.get(`reports/pbi/embedconfig?reportId=${reportId}`);
};

export const AddReport = async (report: AddReportModel) => {
  const result = await axiosInstance.post<ApiResponse<Report>>(
    'reports',
    report
  );
  return result.data.data;
};

export const DeleteReport = async (reportId: string) => {
  const result = await axiosInstance.delete<string>(`reports/${reportId}`);
  return result;
};

export const EditReport = async (report: EditReportModel) => {
  const result = await axiosInstance.put<ApiResponse<Report>>(
    `reports/${report.id}`,
    report
  );
  return result.data.data;
};

export const SearchReport = async (reportName: string) => {
  const result = await axiosInstance.get<ApiResponse<ReportView[]>>(
    `reports?query=${reportName}`
  );

  return result.data.data;
};
